import axios from 'axios';
import {
  HOME_FETCH_INVOICE_BEGIN,
  HOME_FETCH_INVOICE_SUCCESS,
  HOME_FETCH_INVOICE_FAILURE,
  HOME_FETCH_INVOICE_DISMISS_ERROR,
} from './constants';
import { builderAuthHeaderWithParams } from '../../common/utils/auth';

export function fetchInvoice(args = {}) {
  return (dispatch) => {
    dispatch({
      type: HOME_FETCH_INVOICE_BEGIN,
    });

    const { page, size } = args;
    const params = {
      page,
      size,
    };

    const options = builderAuthHeaderWithParams(params);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_ORGANIZATION_ENGINE_URL}invoices/`,
        options,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_FETCH_INVOICE_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: HOME_FETCH_INVOICE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchInvoiceError() {
  return {
    type: HOME_FETCH_INVOICE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_FETCH_INVOICE_BEGIN:
      return {
        ...state,
        fetchInvoicePending: true,
        fetchInvoiceError: null,
      };

    case HOME_FETCH_INVOICE_SUCCESS:
      return {
        ...state,
        fetchInvoicePending: false,
        fetchInvoiceError: null,
        invoiceMetadata: action.data,
      };

    case HOME_FETCH_INVOICE_FAILURE:
      return {
        ...state,
        fetchInvoicePending: false,
        fetchInvoiceError: action.data.error,
      };

    case HOME_FETCH_INVOICE_DISMISS_ERROR:
      return {
        ...state,
        fetchInvoiceError: null,
      };

    default:
      return state;
  }
}
